import { Controller } from "@hotwired/stimulus"

// UK registration plates: max 7 characters, letters A-Z and numbers 0-9 only
const MAX_REG_LENGTH = 7

export default class extends Controller {
  static targets = ["input", "submit", "defaultState", "loadingState"]

  formatInput(event) {
    // Convert to uppercase, remove spaces and special characters, enforce max length
    const value = event.target.value
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "")
      .slice(0, MAX_REG_LENGTH)
    event.target.value = value
  }

  submit(event) {
    const value = this.inputTarget.value.trim()

    if (!value) {
      event.preventDefault()
      this.inputTarget.setCustomValidity("Please enter a registration number")
      this.inputTarget.reportValidity()
      this.inputTarget.setCustomValidity("") // Reset for future submissions
      return
    }

    // Show loading state after a tiny delay to let form submit first
    setTimeout(() => {
      this.defaultStateTarget.classList.add("hidden")
      this.defaultStateTarget.classList.remove("flex")
      this.loadingStateTarget.classList.remove("hidden")
      this.loadingStateTarget.classList.add("flex")
      this.submitTarget.disabled = true
    }, 10)
  }
}
